var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{
        'compare-btn': true,
        'compare-btn--active': _vm.isAnalysisMode,
        'compare-btn--disabled': _vm.disabled,
    }},[_c('span',{staticClass:"compare-btn__wrapper",on:{"click":_vm.toggleAnalysisMode}},[_c('div',{staticClass:"text"},[_vm._v("Compare Mode")]),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"arrows"},[_c('i',{staticClass:"icon-Comparisonicon"})])}]

export { render, staticRenderFns }